import { Fragment, useEffect, useState } from 'react';
import { Alert, Snackbar, Stack } from '@mui/material';
import React from 'react';

import { WellTrackLane } from './WellTrackLane';
import { GetAllTracking, GetCrossSection } from '../API/useLogViewerController';
import { ICrossSectionItem } from 'features/cross-section/models/interfaces/ICrossSectionItem';

let tracks = [{name:`track 1`},{name:`track 2`},{name:`track 3`}];

export function WellViewerPanel(){
    const trackingRequests = GetCrossSection('0614f6ae-fac5-493e-bedc-567a242b8e2c');
    const crossSectionItens = trackingRequests.data?.Itens;
    console.log(crossSectionItens);

    // eslint-disable-next-line no-restricted-globals
    const [ showFullScreenAlert, setShowFullScreenAlert ] = useState(screen.availWidth !== window.innerWidth);

    useEffect(() => {
        window.addEventListener('resize', () => {
            // eslint-disable-next-line no-restricted-globals
            setShowFullScreenAlert(screen.availWidth !== window.innerWidth);
        });
    }, []);

    return (
        <React.Fragment>
            <Stack direction="row" spacing={2}>
                {trackingRequests.isFetched && crossSectionItens?.map((el:ICrossSectionItem) =><WellTrackLane crossSectionItem={el}></WellTrackLane>)}

                {/* {tracks.map(track =><WellTrackLane></WellTrackLane>)} */}
            </Stack>
            <Snackbar open={!!showFullScreenAlert} anchorOrigin={{vertical: 'bottom', horizontal: 'center'}} onClose={() => setShowFullScreenAlert(false)}>
                <Alert variant='filled' severity="info">For the best experience, please maximize your browser window. Some features may not work properly unless the screen is fully expanded.</Alert>
            </Snackbar>
        </React.Fragment>
    );
}
